import { TFunction } from 'next-i18next'
import { RegisterOptions, ValidationValueMessage } from 'react-hook-form'

export const requiredValidation =
  (t: TFunction) =>
  (name: string): RegisterOptions => ({
    // The name should match the localisations in 'consumerLending:affordability:error:required_${name}`
    required: t('consumerLending:affordability:error:required', { context: name }) as unknown as string,
  })

export const amountValidation =
  (t: TFunction) =>
  (isRequired: boolean = false, name: string = ''): { max: ValidationValueMessage<number>; min?: ValidationValueMessage<number> } => {
    return {
      max: {
        value: 99999,
        message: t('consumerLending:affordability:validation:max', { context: name }),
      },
      min: isRequired
        ? {
            value: 0.01,
            message: t('consumerLending:affordability:validation:min', { context: name }),
          }
        : undefined,
    }
  }
